import { config } from '@config'
import { storage } from '@services/storageService'
import axios from 'axios'

export class SyncData {
  syncBSGData = async (syncFlags, buyingSessionGroupId?: string) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}sync/bsgSync`
      const accessToken: string = storage.getItem('access_token')
      const body = {
        ...(buyingSessionGroupId && { buyingSessionGroupId }),
        syncFlags
      }
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (e) {
      console.log(e)
      // throw e
    }
  }

  // Helper function to make the POST request
  makePostRequest = async (url: string, body: object) => {
    try {
      const accessToken: string = storage.getItem('access_token')
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error(`Error during API request to ${url}:`, error)
      throw error
    }
  }

  syncGlobalData = async syncFlags => {
    try {
      let responseObject: any = {}
      // Sync data for clients data, markup/discounts, price list
      if (
        syncFlags?.clientsDataCode ||
        syncFlags?.markupOrDiscounts ||
        syncFlags?.priceList
      ) {
        const url = `${config.buyingBoardServiceRestEndpoint}sync/globalSync`
        const body = { syncFlags }
        const data = await this.makePostRequest(url, body)
        responseObject = { ...responseObject, ...data }
      }

      if (syncFlags?.exchangeTableAndExchangeRate) {
        // Sync data for Exchange Table
        await this.makePostRequest(
          `${config.buyingBoardServiceRestEndpoint}core/migrate/exchange-table`,
          {}
        )

        // Sync data for Exchange Rate
        await this.makePostRequest(
          `${config.buyingBoardServiceRestEndpoint}core/migrate/exchange-rate`,
          {}
        )
        responseObject['exchangeTableAndExchangeRate'] = {
          message: `Exchange Table and Exchange Rate Data Sync Successfully`
        }
      }
      return responseObject
    } catch (e) {
      console.log(e)
      // throw e
    }
  }
}
